// Small pieces that every page shares.

import type { ComponentChildren } from "preact";
import { Button } from "../../../ui/src/index.ts";
import type { ButtonVariant } from "../../../ui/src/index.ts";
import type { ExamplesStatus } from "./store.ts";

/** Says why there are no lessons or use cases yet: they're built from GET /v1/examples once the consumer is signed in. */
const EXAMPLES_NOTE: Record<ExamplesStatus, string> = {
  idle: "Loading examples from the hubs…",
  loading: "Loading examples from the hubs…",
  ready: "No hub lists example questions here yet.",
  failed: "The examples couldn't be loaded. Reload to try again.",
};

export const ExamplesNote = ({ examples }: { examples: ExamplesStatus }) => (
  <p class="ui-empty" role="status">{EXAMPLES_NOTE[examples]}</p>
);

/** A control that the prototype doesn't connect yet, shown the same everywhere. */
export const NotConnected = ({ children, label, size, variant }: { children: ComponentChildren; label: string; size?: "sm" | "md"; variant?: ButtonVariant }) => (
  <Button size={size} variant={variant} aria-disabled="true" title="Not connected in this prototype" onClick={(e) => e.preventDefault()}>
    {children}<span class="ui-sr-only"> ({label}: not connected)</span>
  </Button>
);
